import { ShareCanvasDialog } from "@/action-dialog/dialogs/ShareCanvasDialog";
import type { Canvas } from "@cohesive/api-client";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type ShareCanvasCallableProps = {
  canvas: Canvas;
};

export const ShareCanvasCallable = createCallable<
  ShareCanvasCallableProps,
  boolean
>(({ call, canvas }) => {
  return <ShareCanvasDialog canvas={canvas} onClose={() => call.end(false)} />;
}, UNMOUNTING_DELAY_MS);

ShareCanvasCallable.displayName = "ShareCanvasCallable";
